import React from 'react';
// import PropTypes from 'prop-types';
import './DemandIndicator.css';
import coolingIcon from './assets/cooling-icon.png';
import fanRunningIcon from './assets/fan-on-icon.png';
import heatingIcon from './assets/heating-icon.png';
import occupiedIcon from './assets/occupied-icon.png';
import auxHeatIcon from './assets/heating-icon.png';

export interface Props {
  active: boolean;
  demand: string;
  disabled?: boolean;
  setting?: string;
}

export const DemandIndicator = (props: Props) => {
  const { demand, active, setting = '', disabled = false } = props;
  let demandImage;
  let altText;
  switch (demand) {
    case 'state':
      if (setting === 'heat') {
        demandImage = heatingIcon;
      } else if (setting === 'cool') {
        demandImage = coolingIcon;
      } else if (setting === 'aux_heat') {
        demandImage = auxHeatIcon;
      } else {
        return null;
      }
      altText = 'Adjusting temperature';
      break;
    case 'isFanRunning':
      demandImage = fanRunningIcon;
      altText = 'Fan Active';
      break;
    case 'isOccupied':
      demandImage = occupiedIcon;
      altText = 'Occupied';
      break;
    default:
      return null;
  }

  let demandClasses = 'demand-icon';
  const demandOn = ' demand-icon--on';
  demandClasses += !disabled && active ? demandOn : '';

  return <img className={demandClasses} src={demandImage} alt={altText} />;
};
